import React, { useState, useRef, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
//
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
// import Cookies from 'js-cookie'

const SurveyComponent = ({ surveyModel }) => {
  const [showSurvey, setShowSurvey] = useState(false)

  useEffect(() => {
    setShowSurvey(false)

    const timer = setTimeout(() => {
      setShowSurvey(true)
    }, 300)

    return () => clearTimeout(timer)
  }, [surveyModel])

  return showSurvey ? <Survey model={surveyModel} /> : <></>
}

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h4>問卷正在提交中，請稍候。</h4><h4>Your questionnaire is being submitted. Please wait.</h4><h4>請在成功頁面顯示後再離開。</h4><h4>Please do not leave until the success page is displayed.</h4>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }
  const firstTime = '{q2} = 0'

  const visibleIfConditionsInit = {
    q3: '{q2} = 0',
    q4: '{q2} = 1',
    q5: '({q2} = 0 and {q3} = 1) or ({q2} = 1 and {q4} = 1)',
    q6: '{q2} = 0 and {q3} = 0',
    q7: '{q2} = 0 and {q3} = 0',
    q8: '{q2} = 0 and {q3} = 0',
    q9: '({q2} = 0 and {q3} = 0) or ({q2} = 1 and {q4} = 0)',
    q10: firstTime,
    q11: firstTime,
    q12: firstTime,
    q14: '{q13} anyof [0]',
    q15: '{q13} anyof [1]',
    q16: '{q13} anyof [2]',
    q17: '{q13} anyof [3]',
    q18: '{q13} anyof [4]',
    q19: '{q13} anyof [5]',
    q20: '{q13} anyof [0] and {q14} anyof [0, 1]',
    q21: '{q13} anyof [0] and {q14} anyof [0, 1]',
    q22: '{q13} anyof [0] and {q14} anyof [0, 1]',
    q23: '{q13} anyof [1] and {q15} anyof [0]',
    q24: '{q13} anyof [1] and {q15} anyof [0]',
    q25: '{q13} anyof [1] and {q15} anyof [1]',
    q26: '{q13} anyof [1] and {q15} anyof [1]',
    q27: '{q13} anyof [1] and {q15} anyof [2]',
    q28: '{q13} anyof [2] and {q16} anyof [0]',
    q29: '{q13} anyof [2] and {q16} anyof [0] and ({q28} = 0 or {q28} = 1 or {q28} = 2)',
    q30: '{q13} anyof [2] and {q16} anyof [0] and ({q28} = 0 or {q28} = 1 or {q28} = 2 or {q28} = 3)',
    q31: '{q13} anyof [2] and {q16} anyof [1]',
    q32: '{q13} anyof [2] and {q16} anyof [1]',
    q33: '{q13} anyof [2] and {q16} anyof [1]',
    q34: '{q13} anyof [2] and {q16} anyof [2]',
    q35: '{q13} anyof [2] and {q16} anyof [2]',
    q36: '{q13} anyof [2] and {q16} anyof [2]',
    q37: '{q13} anyof [2] and {q16} anyof [3]',
    q38: '{q13} anyof [2] and {q16} anyof [4]',
    q39: '{q13} anyof [2] and {q16} anyof [4]',
    q40: '{q13} anyof [2] and {q16} anyof [4]',
    q41: '{q13} anyof [2] and {q16} anyof [5]',
    q42: '{q13} anyof [2] and {q16} anyof [5]',
    q43: '{q13} anyof [2] and {q16} anyof [5]',
    q44: '{q13} anyof [2] and {q16} anyof [6]',
    q45: '{q13} anyof [2] and {q16} anyof [7]',
    q46: '{q13} anyof [3] and {q17} anyof [0]',
    q47: '{q13} anyof [3] and {q17} anyof [0]',
    q48: '{q13} anyof [3] and {q17} anyof [1]',
    q49: '{q13} anyof [3] and {q17} anyof [1]',
    q50: '{q13} anyof [3] and {q17} anyof [1]',
    q51: '{q13} anyof [4] and {q18} anyof [0]',
    q52: '{q13} anyof [4] and {q18} anyof [0]',
    q53: '{q13} anyof [4] and {q18} anyof [0]',
    q54: '{q13} anyof [5] and {q19} anyof [0]',
    q55: '{q13} anyof [5] and {q19} anyof [0]',
    q56: '{q13} anyof [5] and {q19} anyof [0]',
    q57: '{q13} anyof [5] and {q19} anyof [1]',
    q58: '{q13} anyof [5] and {q19} anyof [1]',
    q59: '{q13} anyof [5] and {q19} anyof [1]',
    q60: '{q13} anyof [5] and {q19} anyof [2]',
    q61: '{q13} anyof [5] and {q19} anyof [2]',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  const notRequired = [1]
  // const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  // const triggersConditionsInit = [
  //   {
  //     type: 'complete',
  //     expression:
  //       '({q1} = 0) or ({q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3)',
  //     //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
  //   },
  //   {
  //     type: 'complete',
  //     expression: '{q6} notcontains 0',
  //   },
  // ]
  const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const [convertedSurvey, setConvertedSurvey] = useState(null)
  const newConvertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })
  useEffect(() => {
    setConvertedSurvey(newConvertedSurvey)
  }, [newConvertedSurvey])

  const newSurvey = new Model(convertedSurvey)
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])
  // const endMessage = `你填過囉`

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  // const endSurveyMsg = (survey) => {
  //   if (Cookies.get('hasVisited')) {
  //     setCompletionMessage(endMessage)
  //   } else {
  //     Cookies.set('hasVisited', true, { expires: 4, secure: true })
  //     setCompletionMessage('你沒填過')
  //   }
  //   // if (
  //   //   survey.getValue('q1') === 0 ||
  //   //   survey.getValue('q5') === 0 ||
  //   //   survey.getValue('q5') === 1 ||
  //   //   survey.getValue('q5') === 2 ||
  //   //   survey.getValue('q5') === 3
  //   // ) {
  //   //   setCompletionMessage(endMessage)
  //   // } else if (survey.getValue('q6') && !survey.getValue('q6').includes(0)) {
  //   //   setCompletionMessage(endMessage)
  //   // } else {
  //   //   setCompletionMessage(`<h2 style='text-align: center'>問卷已成功送出</h2>`)
  //   // }
  // }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    // endSurveyMsg,
  })
  setIsLoading(false)

  return (
    <>
      {convertedSurvey ? (
        <SurveyComponent surveyModel={newSurvey} setIsLoading={setIsLoading} />
      ) : myAgreeJson ? (
        <SurveyComponent
          surveyModel={agreeSurvey}
          setIsLoading={setIsLoading}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
